import { Col, Row } from 'antd';
import React from 'react';
import { FaHome } from 'react-icons/fa';
import ArquivoInfo from '../../../components/ArquivoInfo';

const Painel: React.FC = () => {



  return (
	  <>
	  	<h1>
			  <FaHome />
			  Painel de Controle
		</h1>

		<Row>
			<Col span={24} md={12}>

			</Col>

			<Col span={24} md={12}>
				<ArquivoInfo />				
			</Col>
		</Row>
		  
	  </>
  );
}

export default Painel;